// ****************
// WARNING:  There is a matching version of this code in R.Web.Apps and R.Marketing.Website
// as all 3 sources need to track the same information
// Please keep all 3 in sync with any changes!!!!!!
// ****************
import { Tracking } from "@common/_constants";
import {
    getTokenFromStorage,
    storeTokenInStorage,
} from "@common/_services/storage.service";
import * as Moment from "moment";

export const TrackingService = {
    addAttribution,
    setTrackingInfo,
};

function getTrackingInfo(): Attribution {
    const now = Moment();
    const attribution: Attribution = {};

    const utmTracking = getTokenFromStorage<Attribution>(Tracking.Storage.ATTRIBUTION_KEY);
    if (!!utmTracking) {
        const expires = Moment(utmTracking.expires);
        if (expires > now) {
            attribution.utm_campaign = utmTracking.utm_campaign;
            attribution.utm_content = utmTracking.utm_content;
            attribution.utm_medium = utmTracking.utm_medium;
            attribution.utm_term = utmTracking.utm_term;
            attribution.utm_source = utmTracking.utm_source;
        }
    }

    const sponsorTracking = getTokenFromStorage<Sponsor>(Tracking.Storage.SPONSOR_KEY);
    if (!!sponsorTracking) {
        const expires = Moment(sponsorTracking.expires);
        if (expires > now) {
            attribution.sponsor = sponsorTracking.sponsor;
        }
    }

    return attribution;
}

function setTrackingInfo(attribution: Attribution) {
    const now = Moment();
    const future = Moment();
    future.add(Tracking.Storage.EXPIRE_DAYS, "days");
    const futureJson = future.toJSON();

    //check each prop.
    if (
        attribution.utm_campaign ||
        attribution.utm_content ||
        attribution.utm_medium ||
        attribution.utm_term ||
        attribution.utm_source
    ) {
        const utmTracking = {
            utm_campaign: attribution.utm_campaign,
            utm_content: attribution.utm_content,
            utm_medium: attribution.utm_medium,
            utm_term: attribution.utm_term,
            utm_source: attribution.utm_source,
            expires: futureJson,
        };
        // Per Marketing, last in wins for UTM up to EXPIRE_DAYS days
        storeTokenInStorage(Tracking.Storage.ATTRIBUTION_KEY, utmTracking);

        console.info(
            `relode | attribution | source: ${attribution.utm_source} | medium: ${
                attribution.utm_medium
            } | ` +
                `campaign: ${attribution.utm_campaign} | content: ${attribution.utm_content} | ` +
                `term: ${attribution.utm_term}`
        );
    }

    if (attribution.sponsor) {
        const existingSponsor = getTokenFromStorage<Sponsor>(Tracking.Storage.SPONSOR_KEY);

        // first in wins for sponsor up to EXPIRE_DAYS days
        if (!existingSponsor || Moment(existingSponsor.expires) < now) {
            const sponsorTracking: Sponsor = {
                sponsor: attribution.sponsor,
                expires: futureJson,
            };

            storeTokenInStorage(Tracking.Storage.SPONSOR_KEY, sponsorTracking);

            console.info(`relode | sponsor | ${sponsorTracking.sponsor}`);
        }
    }
}

function addAttribution(anyObject) {
    const attributions = getTrackingInfo();
    anyObject = { ...anyObject, ...attributions };
    return anyObject;
}

interface Attribution {
    utm_campaign?: string;
    utm_content?: string;
    utm_medium?: string;
    utm_term?: string;
    utm_source?: string;
    sponsor?: string;
    // WARNING: this should be a Date but because it's out there already leaving it a string
    expires?: string;
}

export interface Sponsor {
    sponsor?: string;
    // WARNING: this should be a Date but because it's out there already leaving it a string
    expires?: string;
}
